import cx from 'classnames';
import { useLocale } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { useSpravaSouhlasuDetailContext } from '@gov-nx/module/page';
import { ContentLayout, ErrorStatusBanner, TabsNav } from '@gov-nx/ui/web';
import { CmsPageRender } from '../../../Cms/CmsPageRender';
import { RecallConsentPrompt } from '../RecallConsentPrompt';
import { ConsentManagementDetailSkeleton } from './ConsentManagementDetailSkeleton';
import { ConsentManagementInfo } from './ConsentManagementInfo';
import { ConsentManagementUsers } from './ConsentManagementUsers';

interface ConsentManagementDetailProps {
	code: PageCode;
}

export const ConsentManagementDetailView = ({
	code,
}: ConsentManagementDetailProps) => {
	const {
		controls,
		filteredDetail,
		handleSubmit,
		refInfoBadges,
		view,
		formDefinition,
		isLowAuthorization,
		isAuthorizationEnforced,
		onDialogClose,
	} = useSpravaSouhlasuDetailContext();
	const { t } = useLocale(code);

	const getContent = () => {
		if (controls.initialLoading) {
			return <ConsentManagementDetailSkeleton />;
		}

		if (controls.initialError) {
			return <ErrorStatusBanner code={code} />;
		}

		return (
			<>
				<ConsentManagementInfo code={code} />
				<ConsentManagementUsers code={code} />
				<ContentLayout customClasses="pt-4!">
					<TabsNav>
						{refInfoBadges.map((badge) => (
							<li
								key={badge.name}
								className="gov-tabs__item">
								<button
									className={cx(
										'gov-tabs__btn',
										badge.isActive ? 'selected' : ''
									)}
									aria-label={`${t('formular.wcag.filtrovat')} ${badge.name}`}
									onClick={() => badge.viewFunction()}>
									{badge.name}
								</button>
							</li>
						))}
					</TabsNav>
					{view.referencniUdaje && 'referencni udaje placeholder'}
					{view.nereferencniUdaje && 'nereferencni udaje placeholder'}
					<RecallConsentPrompt
						isOpen={controls.displayModal}
						isLowAuthorization={isLowAuthorization}
						isAuthorizationEnforced={isAuthorizationEnforced}
						formDefinition={formDefinition}
						isConsentRecalling={controls.modalProcessLoading}
						onSubmit={handleSubmit}
						onClose={onDialogClose}
					/>
				</ContentLayout>
			</>
		);
	};

	return (
		<CmsPageRender
			code={code}
			override={{ name: filteredDetail?.nazevOsoby }}
			showDescription={false}>
			{getContent()}
		</CmsPageRender>
	);
};
